import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PalantirTextComponent } from '../text/text.component';
import { PalantirTooltipWhenTruncatedDirective } from './tooltip-when-truncated.directive';
import { PalantirTooltipComponent, PalantirTooltipDirective } from './tooltip.directive';

@NgModule({
  imports: [CommonModule, OverlayModule, PortalModule, PalantirTextComponent],
  declarations: [
    PalantirTooltipDirective,
    PalantirTooltipComponent,
    PalantirTooltipWhenTruncatedDirective,
  ],
  exports: [
    PalantirTooltipDirective,
    PalantirTooltipComponent,
    PalantirTooltipWhenTruncatedDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PalantirTooltipModule {}
